"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = require("lodash");
class Tracker {
    constructor() {
        this.opts = {};
        this.eventQueue = [];
        this.config({
            url: '/analytics/events/batch',
            wait: 3000,
            maxWait: 10000
        });
    }
    config(opts) {
        Object.assign(this.opts, opts);
        this.notifyQueue = (0, lodash_1.debounce)(this.sendEvents.bind(this), this.opts.wait, {
            maxWait: this.opts.maxWait
        });
        return this;
    }
    track(event, flush = false) {
        this.eventQueue.push(event);
        this.notifyQueue();
        if (flush) {
            this.flush();
        }
    }
    flush() {
        this.notifyQueue.flush();
    }
    normalizeProduct(product) {
        product = (product || '').toLowerCase();
        return ['loan', 'deposit'].find(name => name === product);
    }
    sendEvents() {
        const eventCount = this.eventQueue.length;
        if (!eventCount) {
            return;
        }
        const body = JSON.stringify(this.eventQueue.splice(0, eventCount));
        if (window.navigator && window.navigator.sendBeacon) {
            window.navigator.sendBeacon(this.opts.url, body);
        }
        else {
            window.fetch(this.opts.url, {
                method: 'post',
                credentials: 'include',
                headers: {
                    'content-type': 'application/json'
                },
                body
            });
        }
    }
}
exports.default = new Tracker();
